import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AutocompleteItem,
  AutocompleteOption,
} from '@app/forms/formly/types/input-field-with-autocomplete/input-field-with-autocomplete.component';
import { filterAutocompleteItems } from '@app/forms/formly/types/input-field-with-autocomplete/input-field-with-autocomplete.helper';

@Component({
  selector: 'input-field-with-autocomplete-mobile-view',
  templateUrl: './input-field-with-autocomplete-mobile-view.component.html',
  styleUrls: ['./input-field-with-autocomplete-mobile-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFieldWithAutocompleteMobileViewComponent {
  @Input() items: AutocompleteItem[] | null = [];

  @Output() hide = new EventEmitter<void>();
  @Output() selectValue = new EventEmitter<AutocompleteOption>();

  filteredItems: AutocompleteItem[] = [];
  heights: number[] = [];
  filterValue: string;

  onSelectValue(option: AutocompleteOption) {
    this.selectValue.emit(option);
    this.hide.emit();
  }

  onFilterChange(value: string) {
    this.filterValue = value.toLowerCase().trim();

    if (!this.filterValue) {
      this.filteredItems = [];
      return;
    }

    this.filteredItems = filterAutocompleteItems(this.filterValue, this.items ?? []);
    this.heights = this.filteredItems.map((item) => this.getGroupHeight(item));
  }

  trackByItemFn(index: number, option: AutocompleteItem): string {
    return option.options.map((item) => item.value).join('');
  }

  trackByOptionFn(option: AutocompleteOption): string {
    return option.value;
  }

  getGroupHeight(item: AutocompleteItem): number {
    return item.options.length * 20 + (item.options.length - 1) * 12 + 32 + 1;
  }
}
